import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { scrollToId } from "@/lib/scroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Perks from "@/components/Perks";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import Trust from "@/components/Trust";
import BookTrial from "@/components/BookTrial";
import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";

const ENROLL_URL = "https://bit.ly/lssp-fall-enrollment-form";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f3e9] font-sans text-[#00334a]">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero onClaim={() => scrollToId("book-trial")} />
        <Marquee />
        <Perks onEnroll={() => window.open(ENROLL_URL, "_blank", "noopener")} />
        <HowItWorks />
        <Pricing />
        <Trust />
        <BookTrial />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}
